import { photoUrl } from "../lib/api";

export const UpdatePost = ({ u, lang, action, footer }) => (
  <article className="rounded-xl border border-slate-200/80 bg-white p-3" data-testid={`litter-update-${u.id}`}>
    <div className="flex items-start justify-between gap-2">
      <p className="text-[11px] text-slate-400">{new Date(u.created_at).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA", { dateStyle: "medium" })}</p>
      {action}
    </div>
    {u.text && <p className="text-sm text-[#12234A] mt-1 whitespace-pre-line">{u.text}</p>}
    {u.photos?.length > 0 && (
      <div className={`grid gap-1.5 mt-2 ${u.photos.length === 1 ? "grid-cols-1" : "grid-cols-2 sm:grid-cols-3"}`}>
        {u.photos.map((p) => (
          <a key={p} href={photoUrl(p)} target="_blank" rel="noreferrer">
            <img src={photoUrl(p)} alt="" className={`w-full rounded-lg object-cover bg-slate-100 ${u.photos.length === 1 ? "max-h-80" : "h-28"}`} />
          </a>
        ))}
      </div>
    )}
    {footer}
  </article>
);
